
// use this when we want to submit on onChange
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit() {
    refreshCSRFTokens();
    // Safari < 16 (iOS 15.x, macOS 10.15) doesn't support requestSubmit().
    if (typeof this.element.requestSubmit === "function") {
      this.element.requestSubmit();
    } else {
      this.element.submit();
    }
  }
}
